import React from 'react';
import { ORDER_STATUS_OPTIONS } from '../common/constants';
import useRetainedTableState from '../hooks/useRetainedTableFilterState';
import SelectComponent from './SelectComponent';

const OrderStatusSelect = ({
  finalWhereFiltersRef,
  finalWhereFilters,
  setFinalWhereFilters,
  fetchOrders,
  setIsOrderLoading,
  tableFilterKey = null,
}) => {
  const { saveRetainedFilterState } = useRetainedTableState();
  const handleFilterChange = (value) => {
    setIsOrderLoading(true);
    setFinalWhereFilters({ ...finalWhereFilters, statusTiming: value });
    if (tableFilterKey)
      saveRetainedFilterState([tableFilterKey], {
        filters: { ...finalWhereFilters, statusTiming: value },
      });

    if (finalWhereFiltersRef)
      // eslint-disable-next-line no-param-reassign
      finalWhereFiltersRef.current = {
        ...finalWhereFiltersRef?.current,
        statusTiming: value,
      };
    fetchOrders();
  };

  return (
    <div>
      <SelectComponent
        className="mr-8 order-status-select"
        placeholder="Select Status Type"
        showAction={['click']}
        showSearch={false}
        options={ORDER_STATUS_OPTIONS}
        onChange={(value) => handleFilterChange(value)}
        allowClear
        value={finalWhereFilters?.statusTiming}
      />
    </div>
  );
};

export default OrderStatusSelect;
